/*
 * Candidate Qualifications Tab Messages
 *
 * This contains all the text for the Candidate Qualifications Tab component.
 */

import { defineMessages } from 'react-intl';
export const scope =
  'src.pages.CandidatesDetailsPage.components.CandidateQualificationsTab';

export default defineMessages({
  projectCertificates: {
    id: `${scope}.projectCertificates`,
    defaultMessage: 'Project Certificates',
  },
  language: {
    id: `${scope}.language`,
    defaultMessage: 'Language',
  },
  driverLicense: {
    id: `${scope}.driverLicense`,
    defaultMessage: 'Driver License',
  },
  healthCertificates: {
    id: `${scope}.healthCertificates`,
    defaultMessage: 'Health Certificates',
  },
  available: {
    id: `${scope}.available`,
    defaultMessage: 'Available',
  },
  notAvailable: {
    id: `${scope}.notAvailable`,
    defaultMessage: 'Not Available',
  },
  certificate: {
    id: `${scope}.certificate`,
    defaultMessage: 'Certificate {index}',
  },
  validFrom: {
    id: `${scope}.validFrom`,
    defaultMessage: 'Valid from',
  },
  validUntil: {
    id: `${scope}.validUntil`,
    defaultMessage: 'Valid until',
  },
  expired: {
    id: `${scope}.expired`,
    defaultMessage: 'Expired',
  },
  active: {
    id: `${scope}.active`,
    defaultMessage: 'Active',
  },
});
